<template>
  <v-container fluid>
    <v-row align="center" justify="center" style="height: 95vh;">
      <v-col cols="5">
        <v-card style="background-color: rgba(0, 0, 0, 0)" class="text-center px-7 py-10" outlined>
          <div>
            <div class="d-flex align-center justify-center mb-3">
              <v-img src="https://hub.swiset.com/wp-content/uploads/2021/06/Swiset-Confirmation.png"
                  class="mb-2" position="center center" max-width="100px" contain/>
            </div>
            <h2>{{ titleMessage }}</h2>
            <p>{{ bodyMessage }}</p>
            <v-btn @click="goToAction">
              {{ goToMessage }}
              <v-icon class="ml-2" x-small>fa-regular fa-angle-double-right</v-icon>
            </v-btn>
          </div>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "Confirmation",
  props: {
    titleMessage: String,
    bodyMessage: String,
    goToMessage: String,
    afterConfirmationRoute: String
  },
 
  methods: {
    
    goToAction() {
      this.$router.push(`/${this.afterConfirmationRoute}`);
    }
  }
}
</script>

<style scoped>

</style>
